import type { ReactElement, ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

interface EmptyStateProps {
  readonly icon: IconName;
  readonly title: string;
  readonly text: string;
  readonly action?: ReactNode;
}

export function EmptyState({ icon, title, text, action }: EmptyStateProps): ReactElement {
  return (
    <div className="empty">
      <span className="empty__art">
        <Icon name={icon} size={26} />
      </span>
      <p className="empty__title">{title}</p>
      <p className="empty__text">{text}</p>
      {action === undefined ? null : <div style={{ marginTop: 8 }}>{action}</div>}
    </div>
  );
}
